module.exports = __webpack_public_path__ + "img/ClickForSound_40.03fbd15a.png";